import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#14a665",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("circle", {
        cx: "11",
        cy: "11",
        r: "9.75"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M6.5 10.842 9.658 14l6-6"
      })
    ], -1)
  ]))]))
}
export default { render: render }